// extracted by mini-css-extract-plugin
export default {"rodapeArquivos":"visualizador_rodapeArquivos__UnTOw","viewer":"visualizador_viewer__oozuz"};